<div class="w-full max-w-7xl items-center">
  <section class="mt- mb-8 flex lg:mb-0">
    <div
      class="w-full max-w-xl rounded-xl bg-white p-8 text-black shadow-lg md:p-10"
    >
      <!-- Comcast Business | Nitel Logo -->
      <div class="flex items-center justify-center">
        <a routerLink="/" class="inline-block" title="Go to homepage">
          <img
            src="assets/images/logos/comcast_bussiness_nitel_logo.png"
            alt="Comcast Business | Nitel Logo"
            class="h-24 w-auto lg:h-28"
          />
        </a>
      </div>

      @if (!hasError()) {
        <h2 class="mt-4 font-montserrat text-2xl font-bold text-black">
          You are about to impersonate...
        </h2>
        <div class="mt-4 flex justify-center">
          <mat-spinner [diameter]="75"></mat-spinner>
        </div>
      } @else {
        <p class="text-lg">
          You are not authorized to impersonate. Please go through the proper
          channels to impersonate a user.
        </p>
      }
    </div>
  </section>
</div>
